module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-left"
  }, [_c('img', {
    staticClass: "header-left-img",
    attrs: {
      "src": require("../assets/logo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "header-left-img1",
    attrs: {
      "src": require("../assets/image/youxiu_logo_wenzi@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), (_vm.isSubPage) ? _c('div', {
    staticClass: "header-back",
    on: {
      "click": _vm.goBack
    }
  }, [_c('img', {
    staticClass: "header-back-img",
    attrs: {
      "src": require("../assets/image/shangyiji_46@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), (_vm.$route.path === '/zhibozhongxin') ? _c('span', {
    staticClass: "header-back-title"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibozhongxin')) + "·"), _c('span', {
    staticClass: "header-back-status"
  }, [_vm._v(_vm._s(_vm.$t('all.yikaifang')))])]) : (_vm.$route.path === '/huifang') ? _c('span', {
    staticClass: "header-back-title"
  }, [_vm._v(_vm._s(_vm.$t('all.guankanhuifang')))]) : (_vm.$route.path === '/zhiboshangpin') ? _c('span', {
    staticClass: "header-back-title"
  }, [_vm._v(_vm._s(_vm.$t('all.zhiboshangpin')) + " · "), _c('span', {
    staticClass: "header-back-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('all.laiziyunimall')))])]) : (_vm.$route.path === '/zhibozhong') ? [(_vm.$route.query.name) ? [_c('img', {
    staticClass: "header-back-avatar",
    attrs: {
      "src": _vm.$route.query.backgroundUrl || '',
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header-back-user"
  }, [_c('span', {
    staticClass: "header-back-name"
  }, [_vm._v(_vm._s(_vm.$route.query.name || ''))]), _vm._v(" "), _c('span', {
    staticClass: "header-back-subtitle"
  }, [_vm._v(_vm._s(_vm.$route.query.categoryName || ''))])])] : (_vm.liveRoomInfo) ? [_c('img', {
    staticClass: "header-back-avatar",
    attrs: {
      "src": _vm.liveRoomInfo.hostUserInfo && _vm.liveRoomInfo.hostUserInfo.headPortrait || '',
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header-back-user"
  }, [_c('span', {
    staticClass: "header-back-name"
  }, [_vm._v(_vm._s(_vm.liveRoomInfo.hostUserInfo && _vm.liveRoomInfo.hostUserInfo.nickName || ''))]), _vm._v(" "), _c('span', {
    staticClass: "header-back-subtitle"
  }, [_vm._v(_vm._s(_vm.liveRoomInfo.categoryName || ''))])])] : _c('span', {
    staticClass: "header-back-title"
  }, [_vm._v(_vm._s(_vm.$t('all.guankanzhibo')))])] : _c('span', {
    staticClass: "header-back-title"
  }, [_vm._v(_vm._s(_vm.subPageTitle))])], 2) : _vm._e()]), _vm._v(" "), (_vm.$store.state.count == 2 && !_vm.isSubPage) ? _c('div', {
    staticClass: "sousuo"
  }, [_c('div', {
    staticClass: "sousuo-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    staticClass: "box-input-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('all.sousuoniganxingqudeneirong'),
      "placeholder-style": "color:rgba(255,255,255,0.6)",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sousuo-right",
    on: {
      "click": _vm.handleSearchInput
    }
  }, [_c('div', {
    staticClass: "sousuo-right-xian"
  }), _vm._v(" "), _c('img', {
    staticClass: "sousuo-right-img",
    attrs: {
      "src": require("../assets/image/sousuo_18@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sousuo-right-span"
  }, [_vm._v(_vm._s(_vm.$t('all.sousuo')))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header-right"
  }, [_c('div', {
    staticClass: "header-right-item",
    on: {
      "click": function($event) {
        return _vm.handleShowModalVisible(4)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/appxiazai.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.appxiazai')))])]), _vm._v(" "), _c('div', {
    staticClass: "header-right-item",
    on: {
      "click": function($event) {
        return _vm.handleShowModalVisible(1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/xitongxiaoxi_18_1@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.xitongxiaoxi')))]), _vm._v(" "), (_vm.$store.state.sysMsgCount > 0) ? _c('div', {
    staticClass: "header-right-item-num"
  }, [_vm._v(_vm._s(_vm.$store.state.sysMsgCount))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "header-right-item",
    on: {
      "click": function($event) {
        return _vm.handleShowModalVisible(2)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/wodedingdan_1@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.wodedingdan')))])]), _vm._v(" "), _c('div', {
    staticClass: "header-right-item",
    on: {
      "click": function($event) {
        return _vm.handleShowModalVisible(3)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/bangzhufankui_1@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.bangzhufankui')))])]), _vm._v(" "), (_vm.$store.state.userInfo) ? _c('img', {
    staticClass: "header-right-img",
    attrs: {
      "src": _vm.$store.state.userInfo.headPortrait,
      "alt": ""
    },
    on: {
      "error": _vm.handleImgError,
      "click": _vm.handleTiaozhuan
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.$store.state.userInfo) ? _c('img', {
    staticClass: "header-right-img",
    attrs: {
      "src": _vm.defaulImg,
      "alt": ""
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('aside', {
    staticClass: "menu-expanded"
  }, [_c('div', {
    staticClass: "aside-box"
  }, _vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? _c('div', {
      class: _vm.$store.state.count === index ? 'active-aside-box-item' : 'aside-box-item',
      on: {
        "click": function($event) {
          return _vm.handlerouter(index, item)
        }
      }
    }, [(_vm.$store.state.count != index) ? _c('img', {
      staticClass: "icon",
      attrs: {
        "src": item.iconCls,
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (_vm.$store.state.count == index) ? _c('img', {
      staticClass: "icon",
      attrs: {
        "src": item.selectedIconCls,
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      class: _vm.$store.state.count === index ? 'aside-box-item-span' : 'aside-box-item-span1'
    }, [_vm._v(_vm._s(_vm.getMenuName(item.children[0].meta)))])]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "aside-bottom"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/wode_sz@2x.png"),
      "alt": ""
    },
    on: {
      "click": _vm.handleShowSz
    }
  }), _vm._v(" "), (_vm.isLogin == 0) ? _c('img', {
    attrs: {
      "src": require("../assets/image/denglu.png"),
      "alt": ""
    },
    on: {
      "click": _vm.handleShowTc
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLogin == 1) ? _c('img', {
    attrs: {
      "src": require("../assets/image/tuichu@2x.png"),
      "alt": ""
    },
    on: {
      "click": _vm.handleShowTc
    }
  }) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1), _vm._v(" "), (_vm.$route.path !== '/zhibozhong') ? _c('div', {
    staticClass: "custom-bg-bottom"
  }, [_c('div', {
    staticClass: "custom-bg-bottom-xy"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.handleShowModel(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('all.yonghuxieyi')))]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.handleShowModel(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('all.yinsixieyi')))]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.handleShowXiazai
    }
  }, [_vm._v(_vm._s(_vm.$t('all.appxiazai')))])]), _vm._v(" "), _c('div', {
    staticClass: "custom-bg-bottom-des"
  }, [_vm._v("COPYRIGHT © 2026 WWW.UNISHOW.LIVE")])]) : _vm._e()])]), _vm._v(" "), (_vm.isModalVisible) ? _c('div', {
    staticClass: "modal-overlay",
    on: {
      "click": function($event) {
        _vm.isModalVisible = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isModalVisible) ? _c('div', {
    staticClass: "modal-overlay-content"
  }, [(_vm.type == 1) ? _c('xitongxiaoxi') : _vm._e(), _vm._v(" "), (_vm.type == 2) ? _c('wodedingdan') : _vm._e(), _vm._v(" "), (_vm.type == 3) ? _c('wentibangzhu', {
    on: {
      "uploadFk": _vm.handleUploadFk
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 4) ? _c('appxiazai') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isFkModalVisible) ? _c('div', {
    staticClass: "modal-overlay-fk",
    on: {
      "click": function($event) {
        _vm.isFkModalVisible = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isFkModalVisible) ? _c('div', {
    staticClass: "modal-overlay-content-fk"
  }, [_c('woyaofankui', {
    on: {
      "closeFk": function($event) {
        _vm.isFkModalVisible = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('shezhi', {
    ref: "sz"
  }), _vm._v(" "), _c('tuichudenglu', {
    ref: "tc"
  }), _vm._v(" "), _c('xieyi', {
    ref: "xieyi"
  }), _vm._v(" "), _c('xiazai', {
    ref: "xiazai"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10cf67cb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 947
// module chunks = 1